import React, {Fragment} from "react";
import dispatchEvent from "../util/dispatchEvent";
import {CART_UPDATED, OPEN_CART} from "../util/events";

class CartIcon extends React.Component
{

    constructor(props) {
        super(props);
        this.state = {
            items: 0
        };
        this.openCart = this.openCart.bind(this);
        this.bindActions = this.bindActions.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        this.bindActions();
    }

    openCart(e) {
        e.preventDefault();
        dispatchEvent(OPEN_CART);
        return false;
    }

    bindActions()
    {
        const body = document.querySelector('body');
        body.addEventListener(CART_UPDATED, this.updateState);
    }

    updateState(e)
    {
        this.setState({
            items: e.data.total_items
        })
    }


    render() {
        return <div onClick={this.openCart}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32.289" height="28.7" viewBox="0 0 32.289 28.7">
                <path id="shopping-cart-light" d="M30.943,3.588H7.247L6.78,1.1A1.345,1.345,0,0,0,5.458,0H.673A.673.673,0,0,0,0,.673v.448a.673.673,0,0,0,.673.673H5.085L9.005,22.7a3.588,3.588,0,1,0,5.761.62H22.9a3.588,3.588,0,1,0,5.607-.777,1.346,1.346,0,0,0-1.305-1.016H10.61l-.673-3.588H28.514a1.345,1.345,0,0,0,1.317-1.071L32.26,5.207A1.345,1.345,0,0,0,30.943,3.588ZM13.454,25.113a1.794,1.794,0,1,1-1.794-1.794A1.8,1.8,0,0,1,13.454,25.113ZM26.01,26.906A1.794,1.794,0,1,1,27.8,25.113,1.8,1.8,0,0,1,26.01,26.906Zm2.139-10.763H9.6L7.583,5.381H30.392Z" fill="#00aada" opacity="0.9"/>
            </svg>
            <span className="icon__blurb">{this.state.items}</span>
        </div>
    }

}

export default CartIcon;
